<template>
  <header class="header-nav">
    <div class="header-box">
      <div class="header-left">
        <div class="logo">
          <div>
            <img src="static/images/logo.png" alt="" />
          </div>
          <h2>{{ sysName }}</h2>
        </div>
      </div>
      <div class="header-right">
        <div v-show="showSearch" class="search">
          <el-input
            v-model.trim="searchContent"
            placeholder="搜索课程/老师"
            @keyup.enter.native="search()"
            clearable
            @clear="search()"
          >
            <el-button
              slot="append"
              class="el-icon-search search-btn"
              @click="search()"
            ></el-button>
          </el-input>
        </div>
        <!-- 二维码 -->
        <!-- <div class="prompt">
          <el-dropdown>
            <span class="font-main-support pointer erweima">
              <i class="el-icon-mobile"></i> <span class="txt">APP下载</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="app-dropdown"
                  style="width: 220px">
                  <div class="left">
                    <img class="erwei"
                      src="../../../assets/images/Android_ewm.png" />
                    <span>Android<br />扫描二维码下载</span>
                  </div>
                  <div class="right">
                    <img class="erwei"
                      src="../../assets/images/avatar.png" />
                    <span>IOS<br />扫描二维码下载</span>
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
        <div class="linkdiv">MyLab</div>
        <div class="linkdiv" @click="toggleSys(myCourseMenu)">我的课堂</div>
        <div class="dropdown">
          <el-dropdown>
            <div class="user">
              <el-avatar
                v-if="userInfo.userid"
                src="@/assets/images/home/mrtx@2x.png"
              >
                <img src="@/assets/images/home/mrtx@2x.png" />
              </el-avatar>
              <h2 v-if="userInfo.userid">{{ userInfo.username }}</h2>
              <h2 v-else class="pointer" @click="login()">登录</h2>
            </div>
            <el-dropdown-menu slot="dropdown" v-if="userInfo.userid">
              <!-- <el-dropdown-item @click.native="showUserInfo">个人信息</el-dropdown-item> -->
              <el-dropdown-item
                v-for="(item, index) in sysList"
                :key="index"
                @click.native="toggleSys(item)"
                ><svg-icon
                  class="margin-right-5"
                  :name="item.icon ? iconNameFormate(item.icon) : ''"
                ></svg-icon>
                {{ item.label }}</el-dropdown-item
              >
              <el-dropdown-item
                @click.native="showPassword"
                v-if="isAuth == 'false'"
                ><svg-icon
                  class="margin-right-5"
                  :name="iconNameFormate('icon_changePassword')"
                ></svg-icon>
                修改密码</el-dropdown-item
              >
              <el-dropdown-item @click.native="signOut"
                ><svg-icon
                  class="margin-right-5"
                  :name="iconNameFormate('icon_logout')"
                ></svg-icon>
                退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- 宽度800的dialog -->
    <el-dialog
      width="800px"
      class="normal-dialog"
      :title="'个人信息'"
      :visible.sync="userInfoDialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      @close="handleClose"
    >
      <el-scrollbar style="height: 100%; width: 100%">
        <!-- 请在以下内容自定义编辑 -->
        <div>
          <div class="user-info">
            <div class="avatar">
              <el-upload
                class="avatar-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :show-file-list="false"
              >
                <img src="@/assets/images/home/avatar.png" class="avatar" />
              </el-upload>
              <button>上传头像</button>
              <span>建议尺寸：512px * 512px</span>
            </div>
            <el-form
              :model="userInfo"
              label-position="right"
              label-width="68px"
            >
              <el-row :gutter="40" type="flex" justify="space-between">
                <el-col :span="12">
                  <el-form-item label="姓名">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="性别">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40" type="flex" justify="space-between">
                <el-col :span="12">
                  <el-form-item label="出生年月">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="手机号码">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40" type="flex" justify="space-between">
                <el-col :span="12">
                  <el-form-item label="民族">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="职级">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40" type="flex" justify="space-between">
                <el-col :span="12">
                  <el-form-item label="工作电话">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="职务">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40" type="flex" justify="space-between">
                <el-col :span="12">
                  <el-form-item label="单位">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="登录名称">
                    <el-input placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <!-- 请在以上内容自定义编辑 -->
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button class="canael" @click="handleClose">取消</el-button>
        <el-button class="save" type="primary" @click="handleClose"
          >保存</el-button
        >
      </span>
    </el-dialog>
    <!-- 宽度600的dialog -->
    <Password-Dialog
      :visible="passWordVisible"
      @cancel="passWordVisible = false"
      @success="changeSuccess"
    ></Password-Dialog>
  </header>
</template>

<script>
import api from '@/utils/requst.js'
import { mapState, mapGetters } from 'vuex'
import string from 'vue-common-laboratory/dist/utils/string.js'
import eventBus from '@/utils/eventBus.js'
export default {
  components: {
    PasswordDialog: () => import('vue-common-laboratory/src/components/common/PasswordDialog.vue')
  },
  data() {
    return {
      sysName: window.SYS_CONFIG.SYSTEM_NAME,
      activetext: 'inform',
      userInfoDialogVisible: false, //用户信息
      pass: '',
      searchContent: this.$route.query.searchContent || '',
      passWordVisible: false,
      sysList: [],
      myCourseMenu: {},
      isAuth: process.env.IS_AUTH
    }
  },
  computed: {
    //用户信息
    ...mapState({
      userInfo: state => state.userInfo
    }),
    //是否显示导航栏的搜索框
    showSearch() {
      return this.$route.meta.showSearch || null
    },
    //table的切换
    activeName: {
      get: function () {
        return this.$route.meta.activeNav || '0'
      },
      set: function (newValue) {
      }
    },
    ...mapGetters({
      getSysList: 'getSysList'
    })
  },
  watch: {
    getSysList(val) {
      this.sysList = val.filter(item => item.label !== '我的课堂')
      this.myCourseMenu = val.filter(item => item.label === '我的课堂')[0] || {}
    },
    // 切换路由时监听导航渲染
    '$route.path'(val) {
    }
  },
  mounted() {
    this.sysList = this.getSysList.filter(item => item.label !== '我的课堂')
    this.myCourseMenu = this.getSysList.filter(item => item.label === '我的课堂')[0] || {}
  },
  methods: {
    iconNameFormate: string.iconNameFormate,
    toggleSys(sys) {
      this.$store.state.keepAliveRoutes = []
      // 外部链接点击跳转
      if (sys.url && (!sys.children || sys.children.length === 0)) {
        window.open(sys.url)
      } else {
        // 什么路由都没有，不应该
        if (!sys.children || sys.children.length === 0) {

        } else {
          // 切换当前按钮高亮样式
          this.sysList.forEach(elem => { elem.active = false })
          sys.active = true

          if (!sys.children[0].children || sys.children[0].children.length === 0) {
            this.$router.push('/' + sys.children[0].id)
          } else if (sys.children[0].children && sys.children[0].children.some(s => (s.hideNav === false || !s.hideNav))) {
            let secondChildren = sys.children[0].children[0]
            if (secondChildren.children && secondChildren.children.some(s => (s.hideNav === false || !s.hideNav))) {
              let thirdChildren = secondChildren.children[0]
              if (thirdChildren.children && thirdChildren.children.some(s => (s.hideNav === false || !s.hideNav))) {
                this.$router.push('/' + sys.children[0].id + '/' + secondChildren.id + '/' + thirdChildren.id + '/' + thirdChildren.children[0].id)
              } else {
                this.$router.push('/' + sys.children[0].id + '/' + secondChildren.id + '/' + thirdChildren.id)
              }
            } else {
              this.$router.push('/' + sys.children[0].id + '/' + secondChildren.id)
            }
          } else {
            this.$router.push('/' + sys.children[0].id)
          }
          this.$store.dispatch('updateRouter', sys.children)
        }
      }
    },
    search() {
      // if (this.searchContent.trim() === '') {
      //   this.$message.warning('请输入您要搜索的内容');
      // } else {
      if (this.$route.path === '/portal/search') {
        eventBus.$emit('handleSearch', this.searchContent);
      } else {
        this.$router.push({ path: '/portal/search', query: { searchContent: this.searchContent } })
      }
      // }
    },
    handleClose() {
      this.userInfoDialogVisible = false
    },
    showUserInfo() {
      this.userInfoDialogVisible = true
    },
    showPassword() {
      this.passWordVisible = true
    },
    //退出登录
    signOut() {
      if (this.isAuth == 'true') {
        api.get('/xxl-sso-server/logoutByToken', {
          logout_token: sessionStorage.getItem('access_token')
        }).then(res => {
          let access_token = sessionStorage.getItem('access_token') || ''
          // 清除所有的cookie
          this.$cookies.keys().forEach(cookie => {
            this.$cookies.remove(cookie)
          })
          sessionStorage.clear()
          window.location.href = `${process.env.LOGIN_URL}/api/oauth2/logout?id_token_hint=${access_token}&post_logout_redirect_uri=${process.env.REDIRECT_URI}`
        })
      } else {
        let return_index_url = sessionStorage.getItem('return_index_url') ? unescape(sessionStorage.getItem('return_index_url')) : ''
        window.location.href = `http://${process.env.VUE_HOST}${this.$config.baseName}?logoutRequest=true` +
          (return_index_url ? `&logoutRedirectUrl=${return_index_url}` : '')
      }
    },
    changeSuccess(data) {
      this.passWordVisible = false
      window.location.href = `http://${process.env.VUE_HOST}${this.$config.baseName}?logoutRequest=true`
    },
    login() {
      console.log(11111111)
      // window.location.href = `http://192.162.130.34:8600/xxl-sso-server/login?redirect_url=http://${process.env.VUE_HOST}${this.$config.baseName}/cas`
      this.$api.common.getCurrUserInfo(res => {
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.header-nav {
  width: 100%;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.4);
  .header-box {
    width: 1200px;
    margin: 0 auto;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header-left {
    display: flex;
    align-items: center;
    .logo {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 32px;
      div {
        width: 85px;
        margin-right: 20px;
        > img {
          width: 100%;
        }
      }
      h2 {
        font-family: ReeJi-BigRuixain;
        font-size: 32px;
        color: #0f132c;
      }
    }
    /deep/ .el-tabs__header {
      margin: 0;
      height: 100%;
    }

    /deep/ .el-tabs__nav {
      height: 68px;
      padding-top: 22px;
    }
    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }
    /deep/ .el-tabs__item.is-active {
      color: #4d85e8;
    }
    /deep/ .el-tabs__active-bar {
      background-color: #4d85e8;
    }
    /deep/ .el-tabs__item {
      padding: 0 24px;
      height: 32px;
      line-height: 25px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    position: relative;
    .search {
      width: 240px;
      height: 32px;
      margin-right: 24px;
      border-radius: 16px;
      overflow: hidden;
      /deep/ .el-input {
        width: 100%;
        background: #fff;
        .el-input__inner {
          width: 100%;
          height: 32px;
          border: none;
          background: #fff;
        }
        .el-input__suffix {
          top: -4px;
        }
        .el-input-group__append {
          border: none;
          background: none;
          padding: 0 16px 0 10px;
          .search-btn {
            cursor: pointer;
            font-size: 18px;
          }
        }
      }
    }

    .prompt {
      /deep/ .el-badge__content.is-fixed {
        top: 10px;
      }
      .erwei {
        width: 360px;
      }
      .erweima {
        // padding-left: 30px;
        position: relative;
        margin-right: 16px;
        font-size: 16px;
        font-weight: 700;
        /deep/ .el-avatar--small {
          height: 24px;
          width: 24px;
          top: -7px;
          position: absolute;
          left: 12px;
        }
        img {
          vertical-align: middle;
          // position: absolute;
          // top: -4px;
          // left: 0px;
          margin-top: -4px;
          height: 24px;
          width: 24px;
          border-radius: 50%;
        }
      }
      .erweima:hover,
      .title:hover {
        color: $--color-primary;
      }
      .el-image {
        vertical-align: middle;
      }
      .el-badge {
        padding-left: 28px;
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
        }
      }
      p {
        width: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #5f677b;
      }
      .inform {
        width: 340px;
        height: 400px;
        padding: 0 20px;
        background: #ffffff;
        box-shadow: 0 20px 60px -10px rgba(77, 133, 232, 0.2);
        border-radius: 4px;
        position: absolute;
        top: 57px;
        left: 0px;
        z-index: 10;
        .el-badge {
          padding: 0;
        }

        /deep/ .el-tabs__header {
          margin: 0 0 20px;
          padding: 0 10px 0 10px;
        }
        /deep/ .el-tabs__item {
          //width: 28px;
          padding: 0 14px;
          &.is-top:nth-child(2) {
            padding-left: 0;
          }
        }
        /deep/ .el-badge__content {
          height: 14px;
          border: 0;
          padding: 0 4px;
          font-size: 12px;
          line-height: 14px;
          background-color: #d40000;
          transform: scale(0.83, 0.83) translateY(-50%) translateX(100%);
        }
        /deep/ .el-badge__content.is-fixed {
          right: -1px;
          top: 12px;
        }
        .all {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          margin-bottom: 16px;
          height: 28px;
          background: rgba(245, 247, 250, 0.6);
          border-radius: 4px;
          span {
            cursor: pointer;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #5f677b;
          }
          .el-checkbox {
            display: flex;
            align-items: center;
            margin: 0;
            white-space: pre-wrap;
          }
        }
        .el-checkbox-group .el-checkbox {
          display: flex;
          margin: 0;
          padding: 12px 0 9px 10px;
          white-space: pre-wrap;
          /deep/ .el-checkbox__input {
            padding-top: 4px;
          }
          /deep/.el-checkbox__label {
          }
          .item-comtent {
            display: flex;
            flex-direction: column;
            p {
              font-family: PingFangSC-Medium;
              font-weight: 500;
              color: #0f132c;
              text-align: left;
              width: 260px;
            }
            span {
              text-align: left;
              margin-top: 2px;
            }
            p.read {
              color: #8f95a5;
            }
          }

          &:hover {
            p {
              color: #0051d9;
            }
            background: rgba(245, 247, 250, 0.6);
          }
        }
        .el-checkbox-group {
          display: flex;
          flex-direction: column;
        }
        .system-info {
          margin-top: -10px;
          li {
            display: flex;
            flex-direction: column;
            padding: 12px 0 9px 10px;
            & > span {
              text-align: left;
              margin-top: 2px;
            }
            & > p {
              text-align: left;
              width: 286px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              font-size: 14px;
              color: #0f132c;
            }
            p.read {
              color: #8f95a5;
            }
            &:hover {
              background: rgba(245, 247, 250, 0.6);
              p {
                color: #0051d9;
              }
            }
          }
        }
        .system-scrollbar {
          height: 336px;
          /deep/ .el-scrollbar__wrap {
            overflow-x: hidden;
          }
        }
      }
      .history-card {
        width: 250px;
        position: absolute;
        top: 57px;
        left: 0px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #0f132c;
        .history-item {
          width: 208px;
          height: 40px;
          margin: 10px 0;
          & > p {
            width: 100%;
            color: #0f132c;
          }
          &:hover {
            & > p {
              color: #0051d9;
            }

            background: rgba(245, 247, 250, 0.6);
          }
        }
      }
      .collect-card {
        width: 250px;
        position: absolute;
        top: 57px;
        left: 0px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #0f132c;
        .collect-item {
          width: 208px;
          height: 40px;
          margin: 10px 0;
          & > p {
            width: 100%;
            color: #0f132c;
          }
          &:hover {
            & > p {
              color: #0051d9;
            }

            background: rgba(245, 247, 250, 0.6);
          }
        }
      }
    }
    .linkdiv {
      margin: 0 24px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      &:hover {
        color: $--color-primary;
      }
    }
    .dropdown {
      padding-left: 24px;
    }
    .user {
      display: flex;
      align-items: center;
      h2 {
        padding-left: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #0f132c;
      }
      .el-avatar {
        width: 48px;
        height: 48px;
      }
    }
  }
}
.user-info {
  padding: 0 36px;
  .avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
    .avatar-uploader {
      width: 100px;
      height: 100px;
    }
    & > button {
      width: 104px;
      height: 32px;
      margin: 12px 0 9px 0;
      background: #0051d9;
      border: none;
      border-radius: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
    }
    & > span {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #8f95a5;
      line-height: 20px;
    }
  }
  .el-form {
    margin-top: 24px;
  }
  .el-input {
    width: 250px;
    height: 40px;
    border: 1px solid #ebedf0;
    border-radius: 4px;

    /deep/ .el-input__inner {
      background: rgba(245, 247, 250, 0.6);
      border: none;
    }
  }
}
.password {
  padding: 16px 56px;
  .suffix {
    display: flex;
    height: 100%;
    align-items: center;
  }
  /deep/ .el-input__inner {
    border: 1px solid #ebedf0;
  }
}

/deep/ .el-badge__content {
  height: 14px;
  border: 0;
  padding: 0 4px;
  font-size: 12px;
  line-height: 14px;
  background-color: #d40000;
  transform: scale(0.83, 0.83) translateY(-50%) translateX(100%);
}
/deep/ .el-badge__content.is-fixed {
  right: 12px;
}
/deep/.el-col-12 {
  height: 52px;
}
/deep/ .el-form-item__label {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 14px;
  color: #8f95a5;
}
.save.el-button {
  width: 76px;
  height: 36px;
  background: #0051d9;
  border-radius: 20px;
}
.canael.el-button {
  width: 76px;
  height: 36px;
  border: 1px solid #ebedf0;
  border-radius: 20px;
}
.app-dropdown {
  display: flex;
  .left,
  .right {
    flex: 1;
    text-align: center;
    padding: 40px 50px 30px;
    img {
      height: 100px;
      width: 100px;
    }
    span {
      display: block;
      text-align: center;
      line-height: 25px;
      font-size: 700;
      color: rgba(67, 84, 105, 0.5);
    }
  }
}
.user-dropdown >>> .el-dropdown-menu__item {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderPortal.vue